import axios from 'axios';

const RR_BASE = process.env.REACT_APP_ROUNDROBIN_API_BASE || 'http://localhost:8002';

const roundrobinApi = axios.create({
  baseURL: `${RR_BASE}/api`,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

// Redirect to login on 401
roundrobinApi.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default roundrobinApi;
